import { render, staticRenderFns } from "./SpecialismTabs.vue?vue&type=template&id=7657a998&"
import script from "./SpecialismTabs.vue?vue&type=script&lang=js&"
export * from "./SpecialismTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports